import { render, staticRenderFns } from "./RelativeExamine.vue?vue&type=template&id=1eaef495&scoped=true"
import script from "./RelativeExamine.vue?vue&type=script&lang=js"
export * from "./RelativeExamine.vue?vue&type=script&lang=js"
import style0 from "./RelativeExamine.vue?vue&type=style&index=0&id=1eaef495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaef495",
  null
  
)

export default component.exports